<template>
  <div>
    <md-progress-bar
      v-if="loading"
      md-mode="query"
    />
    <md-table
      v-if="!loading"
      v-model="apps"
      :table-header-color="tableHeaderColor"
    >
      <md-table-row
        slot="md-table-row"
        slot-scope="{ item }"
      >
        <md-table-cell md-label="id">
          <router-link :to="{ name: 'app', params: { appid: item.id } }">
            {{ item.id }}
          </router-link>
        </md-table-cell>
        <md-table-cell md-label="name">
          {{ item.name }}
        </md-table-cell>
        <md-table-cell md-label="platform">
          {{ item.platform }}
        </md-table-cell>
        <md-table-cell md-label="secret">
          <md-icon
            v-clipboard:copy="item.secret"
            class="gen-key"
          >
            assignment
          </md-icon>
        </md-table-cell>
        <md-table-cell md-label="identity">
          {{ item.identity }}
        </md-table-cell>
        <md-table-cell md-label="url">
          {{ item['app_url'] }}
        </md-table-cell>
      </md-table-row>
    </md-table>
  </div>
</template>

<script>
    export default {
        name: "StoreTable",
        props: {
            tableHeaderColor: {
                type: String,
                default: ""
            }
        },
        data() {
            return {
                loading: true,
                apps: []
            };
        },
        mounted() {
            this.fetchApps();
        },
        methods: {
            fetchApps() {
                this.loading = true;
                this.$http.get("/v1/admin/store/apps").then(result => {
                    this.apps = result.data.apps;
                    this.loading = false;
                }, err => {
                    console.error(err);
                });
            }
        }
    };
</script>
<style scoped>
    .gen-key {
        cursor: pointer !important;
    }
</style>
